import { Link } from "react-router-dom";
import { whatsappHref } from "@/lib/format";

export default function CTASection() {
  return (
    <section data-testid="final-cta" className="py-24 md:py-32">
      <div className="max-w-6xl mx-auto px-5 md:px-8">
        <div className="card-lux p-10 md:p-16 text-center relative overflow-hidden">
          <div className="orb-gold w-[420px] h-[420px] left-1/2 -translate-x-1/2 top-[-100px] opacity-60" />
          <div className="relative">
            <div className="text-[#E8C87A] text-xs uppercase tracking-[0.35em] mb-4">¿Listos?</div>
            <h2 className="font-display text-5xl md:text-6xl leading-[1.05] text-[#F5EFE0]">
              Reserva tu <span className="italic text-gold-grad">próxima ruta</span> hoy
            </h2>
            <p className="mt-5 text-[#F5EFE0]/70 max-w-lg mx-auto">
              Somos el aliado logístico de agencias, empresas y familias que quieren moverse por Colombia sin sobresaltos.
            </p>
            <div className="mt-8 flex flex-wrap justify-center gap-3">
              <Link to="/cotizar" data-testid="cta-quote-btn" className="btn-gold px-8 py-3.5 rounded-full text-[15px]">Solicitar cotización</Link>
              <a href={whatsappHref("573123616674", "Hola Líneas Doradas!")} target="_blank" rel="noreferrer" data-testid="cta-wa-btn" className="btn-ghost-gold px-8 py-3.5 rounded-full text-[15px]">
                Escribir por WhatsApp
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
